import ButtonUI from "../../UI/ButtonUI";
import wb from "./img/wb.svg";
import geo from "./img/geo.svg";
import briefcase from "./img/briefcase.svg";
import ris from "./img/ris.svg";
import hue from "./img/hue.webp";
import hueM from "./img/hue-m.webp";
import risM from "./img/ris-m.svg";

import ym from "react-yandex-metrika";

import { createLinkClick } from '@utils'

import "./style.scss";

const Start = () => {

    const handleClick = () => {
        ym("reachGoal", 'click_connect_instrument');
        createLinkClick('#footer');
    }

    return (
        <div className="start">
            <img className="start__hue" src={hue} />
            <img className="start__hue-m" src={hueM} />

            <div className="start__container">
                <img className="start__ris-m" src={risM} />
                <img className="start__ris" src={ris} />
                <div className="start__links">
                    {linksArr.map((i, idx) => (
                        <a className="start__link" href={i.href} key={idx}>
                            {i.label} <span>{i.label2 ? i.label2 : null}</span>
                        </a>
                    ))}
                </div>

                <div className="start__animate-container">
                    <span className="start__title">
                        <span className="start__title_colored">Легкий способ </span>
                        привлечь больше&nbsp;клиентов
                    </span>
                    <span className="start__subtitle">Витрина промокодов <br/>с эксклюзивными предложениями</span>
                    <ButtonUI label="Подключить инструмент" onClick={handleClick} />
                </div>

                <span className="start__text">От вас нужно лишь предложение — обо&nbsp;всем&nbsp;остальном&nbsp;позаботимся&nbsp;мы</span>

                <div className="start__cards">
                    {cardsArr.map((card, idx) => (
                        <div key={idx} className="start__card">
                            <img src={card.img} className="start__card-img" />
                            <div className="start__card-container">
                                <span className="start__card-title">{card.title}</span>
                                <span className="start__card-subtitle">{card.subtitle}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Start;

const linksArr = [
    { label: "Как работает сервис", href: "#how" },
    { label: "Наша ценность", href: "#value" },
    { label: "Подключить", label2: "сервис", href: "#footer" },
];

const cardsArr = [
    { title: "Эксклюзивный трафик Wildberries", subtitle: "Вовлеченные клиенты, высокая конверсия, охваты по всем регионам", img: wb },
    { title: "Готовы работать от\u00A010\u00A0000 ₽", subtitle: "Мы работаем с ограниченными бюджетами", img: briefcase },
    { title: "Точная настройка ГЕО", subtitle: "Приводим клиентов из вашего города и региона", img: geo },
];
